export const mutations = {
    set_token_sesion(state, data) {
        state.token_sesion = data
    },
    set_datos_usuario(state, data) {
        state.datos_usuario = data
    },
    set_roles(state, data) {
        state.roles = data
    },
    set_usuarios(state, data) {
        state.usuarios = data
    },
    set_usuario_a_editar(state, data) {
        state.usuario_a_editar = data
    },
    set_loading(state, data) {
        state.loading = data
    },
    set_recv_data(state, data) {
        state._recv_data = data
    },
    set_limpiar(state, data) {
        state.limpiar = data
    },
    set__socket(state, data) {
        state._socket = data
    },
    set_correlativos(state, data) {
        state.correlativos = data
    },
    set_id_empresa_seleccionada(state, data) {
        state.id_empresa_seleccionada = data
    },
    set_usuario_datos_principales(state, data) {
        state.objeto_usuario.datos_principales = data
    },
    set_usuario_datos_empresas(state, data) {
        state.objeto_usuario.datos_empresas = data
    },
    set_usuario_datos_sucursales(state, data) {
        state.objeto_usuario.datos_sucursales = data
    },
    set_lista_usuarios_panel(state, data) {
        state.lista_usuarios_panel = data
    },
    set_usuario_seleccionado_permisos(state, data) {
        state.usuario_seleccionado_permisos = data
    },
    set_permisos(state, data) {
        state.permisos = data
    },
    set_empresas_por_usuario(state, data) {
        state.empresas_por_usuario = data
    },
    set_nombre_empresa_seleccionada(state, data) {
        state.nombre_empresa_seleccionada = data
    }
}
